export default "__VITE_ASSET__9304e96c__"